<template>
    <div class="bank_box">
      <a 
       class="link_elementor"
       @click.prevent="handleClick($event)"
        >
       
       {{doubleEncodeAndCreateLink(cellValue)}}
      </a>
    </div>
  </template>
  
  <script>

  export default {
    
    methods: {

        doubleEncodeAndCreateLink(someString) {

            /*
            const url = new URL(someString);
            const originalParam = url.searchParams.get("az");
            
            if (originalParam) {
                // Double encode the parameter value
                const doubleEncodedParam = encodeURIComponent(encodeURIComponent(originalParam));
                
                // Replace the original query parameter with the double encoded one
                url.searchParams.set("az", doubleEncodedParam);
                
                // Explicitly log the double encoded part for verification
                
                
                // Return the modified URL as a string
                console.log("Modified URL:", url.toString());
                return url.toString();
            } else {
                console.log("No 'az' param found in URL");
                */
                return someString; // Return the original string if no 'az' parameter is found
           // }
        },

        handleClick(event){
            this.copyToClipBoard(this.doubleEncodeAndCreateLink(this.cellValue))
            
             
           // console.log('brokerBanks Clicked bank ID:', bankId);
        }, 

         getStringAfterAz(someString) {
            const azIndex = someString.indexOf('az=');
            if (azIndex === -1) {
                return ''; // "az=" not found in the string
            }
            return someString.substring(azIndex + 3); // +3 to skip past "az="
        },

      
      formatDisplayText(linkAddress) {
       // const url = new URL(linkAddress);
        //const shortenedLink = url.hostname.substring(0, 5);
        return linkAddress;
        //return `${shortenedLink}`;
      },
      doNothing: function(){
            return false;
        },
       
        copyToClipBoard: function(value){
            let that = this;
            let text = value;
            let textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                if(document.execCommand('copy'))
                    that.openAlert('success','','copied to clipboard');
            } catch(e) {
                this.doNothing()
                //console.log('Oops, unable to copy');
            }
            document.body.removeChild(textArea);
        },

      



        openAlert(color,title,text) {
            let colorAlert = color;
            this.$vs.notify({
                title: title,
                text: text,
                color: colorAlert
            })
        },
    },
   
    computed: {
        cellValue() {
            //console.log(this.params.value)
            return this.params.value;
           
        }
    },
    
    mounted() {
        
        
       // console.log('Received cell value:', this.cellValue);
    },

  };
  
  </script>
  
  <style>
  .link_elementor{
   
    padding: 5px 10px;
  margin-left: 10px;
  margin-right: 10px;
  color: rgb(115, 103, 240);
  
  }

  
  
  </style>